import gql from 'graphql-tag';

export const ADMIN_DELETE_DASHBOARD = gql`
  mutation DeleteDashboard($input: DeleteExternalDashboardsInput!) {
    externalDashboards {
      result: adminDeleteDashboard(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
